import React, { useState } from "react";
import worthTextImg from "../../../assets/image/worth-text-img.png";
import rightArrowImg from "../../../assets/image/right-arrow-img.png";
import locationImg from "../../../assets/image/submit-address-img.png";
import researchImg from "../../../assets/image/reserch-img.png";
import estimateImg from "../../../assets/image/estimage-img.png";
import consultantImg from "../../../assets/image/consultant-img.png";
import insightsImg from "../../../assets/image/quick-insights-img.png";
import sellerImg1 from "../../../assets/image/howardstcondos.jpg";
import sellerImg2 from "../../../assets/image/somalofts.jpg";
import sellerImg3 from "../../../assets/image/pacificheights.jpg";

import { NewNavbar } from "../Pages/NewNavbar";
import Footer from "../Footer";
import MyForm from "../Components/UI/MyForm";
import { postUserDetails } from "../../../api/leads";
import { errorMessage, successMessage } from "../Util/Toaster";
import { Link } from "react-router-dom";
import { ModalPopUp } from "../Components/UI/ModalPopUp";

export default function WhatIsMyHomeWorth() {
  const [modalOpen, setModalOpen] = useState(false);
  const field = [
    { type: "text", placeholder: "Name", name: "name" },
    { type: "email", placeholder: "Email Address", name: "email" },
    { type: "phone", placeholder: "Phone", name: "phone" },
    { type: "text", placeholder: "Home Address", name: "Address" },
  ];
  const onFormSubmit = async (userDetails, formtype) => {
    const dataForSubmission = {
      ...userDetails,
      type: formtype,
    };
    console.log("dataForSubmission", dataForSubmission);

    try {
      const data = await postUserDetails(dataForSubmission);
      console.log("data", data.data);
      if (data.data > 0) {
        successMessage("Form Submit successfully");
      } else {
        errorMessage("An error occurred during submission.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      errorMessage("An error occurred during submission.");
    }
  };

  return (
    <>
      <NewNavbar buySellActive={false} />
      {/* Home worth banner section start */}
      <section className="worth-banner-section">
        <div className="container">
          <div className="row">
            <h1 className="main-heading">
              What's My Home Worth?
              <img src={worthTextImg} alt="" />
            </h1>
            <MyForm
              fields={field}
              submitTxt={"GET FREE ESTIMATE"}
              inputClass={"w-100 guide-input"}
              classname="col-md-6 col-lg-6 "
              // parentClass={"flex-column"}
              onFormSubmit={(userDetails) => onFormSubmit(userDetails, "5")}
            />
          </div>
        </div>
      </section>
      {/* Home worth banner section end */}
      {/* how we Deliver section start  */}
      <section className="deliver-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="rest-text text-center">NO GUESSWORK HERE</p>
              <h1 className="main-heading">
                How We Deliver Accurate, Local Results
              </h1>
              <div className="deliver-steps">
                <div className="step-section">
                  <img src={locationImg} alt="" />
                  <div className="step-section-content">
                    <p className="step-no">STEP 1</p>
                    <h1>Submit Address</h1>
                  </div>
                </div>
                <div>
                  <img src={rightArrowImg} alt="" />
                </div>
                <div className="step-section">
                  <img src={researchImg} alt="" />
                  <div className="step-section-content">
                    <p className="step-no">STEP 2</p>
                    <h1>We Research</h1>
                  </div>
                </div>
                <div>
                  <img src={rightArrowImg} alt="" />
                </div>
                <div className="step-section">
                  <img src={estimateImg} alt="" />
                  <div className="step-section-content">
                    <p className="step-no">STEP 3</p>
                    <h1>Get Estimate</h1>
                  </div>
                </div>
                <div>
                  <img src={rightArrowImg} alt="" />
                </div>
                <div className="step-section">
                  <img src={consultantImg} alt="" />
                  <div className="step-section-content">
                    <p className="step-no">STEP 4</p>
                    <h1>Optional Consultation</h1>
                  </div>
                </div>
              </div>
              <div className="sub-content">
                Start by entering your home's address so we can begin your
                custom valuation. No commitment required – just the basic info
                we need to get an accurate picture of your property.
              </div>
              <div className="text-center mt-4">
                <Link to="/contactus" className="contact-us-btn ">
                  CONTACT US
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* how we Deliver section end  */}
      {/* Quick insight section start */}
      <section className="quick-insight-section">
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <img src={insightsImg} alt="" className="img-fluid" />
            </div>
            <div className="col-md-7">
              <p className="rest-text">QUICK INSIGHTS</p>
              <h1 className="main-heading">
                Get Clarity on Home Value with these FAQs
              </h1>
              <div className="accordian-container">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="false"
                        aria-controls="collapseOne"
                      >
                        What is a home valuation?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        A home valuation is an estimate of your property's
                        current market value based on factors like location,
                        condition, size, and recent sales in your area.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        How do you calculate my home's value?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        We combine local data, market trends, and recent sales
                        in your neighborhood along with any details you provide
                        to create a custom accurate estimate.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        How can I increase the value of my home?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Simple updates like fresh paint, landscaping, and modern
                        fixtures can make a big difference. Larger renovations
                        like kitchens or bathrooms can boost value even more.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Can a home depreciate in value?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Yes, factors like deferred maintenance, neighborhood
                        changes, or market downturns can impact your home's
                        value. Staying proactive helps protect your investment.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 text-center">
              <button className="submit-btn" onClick={() => setModalOpen(true)}>
                SEE YOUR HOME CUSTOM VALUE NOW
              </button>

              <ModalPopUp
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
              >
                <div className="modal-form quiz-inner-body">
                  <div className="row no-gutters">
                    <div className="col-md-12">
                      <div className="quiz-right-section h-100">
                        <div className="quiz-inner-body">
                          <div className="quiz-question">
                            <MyForm
                              fields={field}
                              submitTxt={"GET FREE ESTIMATE"}
                              inputClass={"w-100 guide-input"}
                              classname="col-md-6 col-lg-6 "
                              onFormSubmit={(userDetails) =>
                                onFormSubmit(userDetails, "5")
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalPopUp>
            </div>
          </div>
        </div>
      </section>
      {/* Quick insight section end */}
      {/* Latest Seller Advice section start */}
      <section className="seller-advice-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1 className="main-heading">Explore Our Latest Seller Advice</h1>
              <p>
                Explore expert-backed tips to guide you through every stage of
                the selling process with clarity and confidence
              </p>
            </div>
            <div className="col-md-4">
              <div className="card-container">
                <img src={sellerImg1} alt="" className="img-fluid" />
                <div className="card-content">
                  <p className="rest-text">Price It Right</p>
                  <p>
                    Start strong with a competitive price to attract more buyers
                    and increase your chances of multiple offers.
                  </p>
                  <div className="play-btn">
                    <i className="fa-solid fa-play play-icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card-container">
                <img src={sellerImg2} alt="" className="img-fluid" />
                <div className="card-content">
                  <p className="rest-text">Declutter Your Space</p>
                  <p>
                    Keep it clean and minimal, less clutter helps buyers picture
                    the home as their own.
                  </p>
                  <div className="play-btn">
                    <i className="fa-solid fa-play play-icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card-container">
                <img src={sellerImg3} alt="" className="img-fluid" />
                <div className="card-content">
                  <p className="rest-text">Let the Light In</p>
                  <p>
                    Natural light makes rooms feel larger, warmer, and more
                    welcoming to potential buyers.
                  </p>
                  <div className="play-btn">
                    <i className="fa-solid fa-play play-icon"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Latest Seller Advice section end */}
      {/* Journey section start */}
      <section className="journy-section">
        <div className="container">
          <div className="row justify-content-end align-items-center h-100">
            <div className="col-12 col-md-7">
              <h1 className="main-heading">
                Start your home journey with confidence today
              </h1>
              <div className="d-flex">
                <a href="/property-list" className="submit-btn">
                  <i className="fa-solid fa-house me-2"></i> FIND YOUR DREAM
                  HOME
                </a>
                <a href="tel:4028800202" className="submit-btn">
                  <i className="fa-solid fa-phone  me-2"> </i> LET'S TALK
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Journey section end */}
      <Footer />
    </>
  );
}
